import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import React from 'react'
import { NavLink } from 'react-router-dom'

const useStyles = makeStyles((theme) => ({
	crumbInt: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center'
	},
	crumb: {
		fontFamily: 'Nunito',
		fontSize: 16,
		fontWeight: 'bold',
		textDecoration: 'none',
		color: '#3B0275',
		marginRight: 5,
		opacity: 0.6
	},
	selectedCrumb: {
		fontWeight: 800,
		fontSize: '16px',
		lineHeight: '22px',
		color: theme.palette.primary.main,
		opacity: 1,
		textTransform: 'uppercase'
	}
}))

const SettingsBreadCrumbs = (props) => {
	const { selectedFacility, location } = props
	const classes = useStyles()

	const getCrumb = () => {
		if (location && location.pathname.includes('checkIn'))
			return (
				<NavLink className={clsx([classes.crumb, classes.selectedCrumb])} to={location.pathname}>
					Bar & Park Settings
				</NavLink>
			)
		if (location && location.pathname.includes('addon'))
			return (
				<NavLink className={clsx([classes.crumb, classes.selectedCrumb])} to={location.pathname}>
					Enrichment Availability
				</NavLink>
			)
		return (
			<NavLink className={clsx([classes.crumb, classes.selectedCrumb])} to={location.pathname}>
				Services Availability
			</NavLink>
		)
	}

	return (
		<div className={classes.crumbInt}>
			<NavLink
				className={classes.crumb}
				to={`/facilities/${selectedFacility ? selectedFacility._id : null}/schedule`}>
				Home /
			</NavLink>

			<NavLink
				className={classes.crumb}
				to={`/facilities/${
					selectedFacility ? selectedFacility._id : null
				}/settings/services/availability`}>
				Settings /
			</NavLink>

			{getCrumb()}
		</div>
	)
}

export default SettingsBreadCrumbs
